<div class="flex flex-col aa-input-general p-5 pt-0 h-155 2xl:h-200">
  <div class="flex justify-between items-center m-4 border-b border-customBlueHard">
    <p class="text-general-title color-blue">
      {{ 'quotation.fieldNames.accessories' | translate }}
    </p>

    <button
      (click)="closeModal()"
      class="flex! justify-center! items-center!"
      color="primary"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="flex gap-4 p-4">
    <div class="flex flex-col gap-1 w-[90%]">
      <div class="subtitleTramite">{{ 'quotation.titles.accessoryAmount' | translate }}</div>
      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">
          {{ 'quotation.fieldNames.maxPercentage' | translate }}
        </mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [placeholder]="'quotation.fieldNames.maxPercentage' | translate"
            [value]="accessoryAmount.maximumPercentage"
            disabled="true"
            maxlength="10"
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">
          {{ 'quotation.fieldNames.cashAccessory' | translate }}
        </mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [placeholder]="'quotation.fieldNames.cashAccessory' | translate"
            [value]="accessoryAmount.cashAccessories"
            disabled="true"
            maxlength="10"
            autocomplete="off"
            [mask]="'separator'"
            [prefix]="'$'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
          />
        </mat-form-field>
      </div>

      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">
          {{ 'quotation.fieldNames.financedAccessories' | translate }}
        </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [placeholder]="'quotation.fieldNames.financedAccessories' | translate"
            disabled="true"
            [value]="accessoryAmount.financedAccessories"
            maxlength="10"
            autocomplete="off"
            [mask]="'separator'"
            [prefix]="'$'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
          />
        </mat-form-field>
      </div>

      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">
          {{ 'quotation.fieldNames.totalAccessories' | translate }}
        </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [placeholder]="'quotation.fieldNames.totalAccessories' | translate"
            disabled="true"
            [value]="accessoryAmount.totalAccessories"
            maxlength="10"
            autocomplete="off"
            [mask]="'separator'"
            [prefix]="'$'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
          />
        </mat-form-field>
      </div>

      <div class="w-full flex aa-input-general flex-col">
        <mat-label class="text-(--comp-input-label-normal) px-4">
          {{ 'quotation.labels.addAccessory' | translate }}
        </mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select (selectionChange)="onChangeAccessory($event)">
            @for (accessory of accessories; track accessory.accesoryId) {
              <mat-option [value]="accessory.accesoryId">
                {{ accessory.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full flex justify-center">
        <button
          matButton="filled"
          class="w-full h-12! rounded-xl text-white! text-general bg-primary!"
          (click)="insertAccessory()"
        >
          {{ 'quotation.labels.add' | translate }}
        </button>
      </div>
    </div>

    <div class="rightSubtitle">
      <div class="subtitleTramite rightWidth">
        {{ 'quotation.titles.selectedAccessories' | translate }}
      </div>
      <div class="table">
        <table mat-table [dataSource]="quotationAccessories" class="mat-elevation-z8">
          <ng-container matColumnDef="Descripcion">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'quotation.fieldNames.description' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="input-descripcion">
              @if (
                element.accesoryDescription != 'BLINDAJE' && element.accesoryDescription != 'CAJA'
              ) {
                <div class="pt-4">
                  <mat-form-field appearance="outline" class="w-full">
                    <input
                      matInput
                      type="text"
                      id="accessoryDescription{{ element.id }}"
                      [(ngModel)]="accessoryDescription[element.id]"
                      (value)="(element.description)"
                      (change)="updateAccesory(element)"
                      [disabled]="
                        element.accesoryDescription === 'BLINDAJE' ||
                        element.accesoryDescription === 'CAJA' ||
                        element.accesoryDescription === 'PAQUETE DE SERVICIOS' ||
                        element.accesoryDescription === 'GARANTIA'
                      "
                    />
                  </mat-form-field>
                </div>
              }
              @if (
                element.accesoryDescription === 'BLINDAJE' || element.accesoryDescription === 'CAJA'
              ) {
                <div class="pt-4 flex justify-center items-center">
                  {{ element.accesoryDescription }}
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="Precio">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'quotation.fieldNames.price' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="pt-4">
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    id="accessoryInputs{{ element.id }}"
                    [(ngModel)]="accessoryInputs[element.id]"
                    (value)="(element.cost)"
                    (keypress)="keyPressNumbersWithDecimal($event)"
                    (change)="updateAccesory(element)"
                    [mask]="'separator'"
                    [prefix]="'$'"
                    [thousandSeparator]="','"
                    [allowNegativeNumbers]="true"
                  />
                </mat-form-field>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="FinanciadoContado">
            <th mat-header-cell *matHeaderCellDef>{{ 'quotation.titles.payType' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <div class="pt-4">
                <mat-form-field appearance="outline" class="input-mat-form-field">
                  <mat-label>{{ 'quotation.titles.payType' | translate }}</mat-label>
                  <mat-select
                    (selectionChange)="onChangeIncome($event, element)"
                    [(ngModel)]="accessorySelects[element.id]"
                    id="accessorySelects{{ element.id }}"
                  >
                    <mat-option value="SI">{{
                      'quotation.fieldNames.financed' | translate
                    }}</mat-option>
                    <mat-option value="NO">{{
                      'quotation.fieldNames.cash' | translate
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Rent">
            <th mat-header-cell *matHeaderCellDef>
              <div class="w-20">
                {{ 'quotation.titles.addRent' | translate }}
              </div>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="flex justify-center">
                <mat-checkbox
                  (checked)="(element.isInIncome)"
                  (change)="onCheckIncome($event, element)"
                  id="accessorysCheckbox{{ element.id }}"
                  [(ngModel)]="accessorysCheckbox[element.id]"
                ></mat-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="Delete">
            <th mat-header-cell *matHeaderCellDef>
              <div class="w-14"></div>
            </th>
            <td mat-cell *matCellDef="let element">
              <button matIconButton (click)="openDialogConfirm(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>

  <div class="w-full flex justify-center pb-4">
    <button
      matButton="filled"
      class="w-[180px] h-12! rounded-xl text-white! text-general bg-primary!"
      (click)="closeAccessory()"
    >
      {{ 'quotation.labels.update' | translate }}
    </button>
  </div>
</div>
